import {
  ReversibleDivergence,
  ReversibleInstallment,
} from "./reversal-effect";

export interface ReversibleSource {
  id: number | string;
  version: number;
  amount?: number | string | null;
  store_code?: number | string | null;
  is_loss?: boolean | null;
  justification_id?: number | null;
  payroll_voucher?: {
    installments?: readonly ReversibleInstallment[] | null;
  } | null;
}

export type ReversibleTarget = ReversibleDivergence & {
  id: number;
  version: number;
};

export const toReversible = (row: ReversibleSource): ReversibleTarget => ({
  id: Number(row.id),
  version: row.version,
  amount: row.amount ?? 0,
  store_code: row.store_code ?? "",
  is_loss: row.is_loss ?? null,
  justification_id: row.justification_id ?? null,
  installments: row.payroll_voucher?.installments ?? [],
});
